import Typography from "typography"
import usWebDesignStandardsTheme from "typography-theme-us-web-design-standards"

const typography = new Typography({
  baseFontSize: "16px",
  baseLineHeight: 1.53,
  headerFontFamily: [
    "Avenir Next Satchel",
    "Avenir Next",
    "Helvetica Neue",
    "sans-serif",
  ],
  bodyFontFamily: [
    "Avenir Next Satchel",
    "Avenir Next",
    "Helvetica Neue",
    "sans-serif",
  ],
  headerWeight: 600,
  boldWeight: 600,
  // See below for the full list of options.
})

export default typography
export const rhythm = typography.rhythm
